import React, { Component } from 'react';

export const ErrorBoundary = (WrappedComponent) => class extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: null };
  }

  componentDidCatch() {
    this.setState({ hasError: true });
  }

  render() {
    return <WrappedComponent {...this.props} hasError={this.state.hasError}/>;
  }
};



// WEBPACK FOOTER //
// ./src/components/errorBoundary/errorBoundary.js